import React from "react"
import { FormattedMessage } from "react-intl"
import Icon from "../icon/icon.component"
import { ButtonProps } from "../types/button"
import ActionButton from "./actionbutton.component"

export const EmailButton = (props: ButtonProps) => {
    return (
        <span className={"pr-2 m-0"}>
            <ActionButton
                isLoading={props.isLoading ?? false}
                disabled={props.disabled ?? false}
                className={"btn btn-success" + (props.className ?? "")}
                onClick={props.onClickCallback}
            >
                <Icon value={"envelope"} className={"mr-1"}/>
                <FormattedMessage
                    id="common.button.email"
                    defaultMessage="Email"
                />
            </ActionButton>
        </span>
    )
}


// WEBPACK FOOTER //
// ./src/common/button/EmailButton.tsx